import { render, staticRenderFns } from "./PracticeEditor.vue?vue&type=template&id=b5034e00&scoped=true"
import script from "./PracticeEditor.vue?vue&type=script&lang=js"
export * from "./PracticeEditor.vue?vue&type=script&lang=js"
import style0 from "./PracticeEditor.vue?vue&type=style&index=0&id=b5034e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5034e00",
  null
  
)

export default component.exports